import mutations from '@/store/modules/browser/pages/pages.mutations';
import actions from '@/store/modules/browser/pages/pages.actions';
// import getters from '@/store/modules/browser/application/application.getters';
// TODO add progressively

export interface State {
  services: any[];
  pagesMetaData: any[];
  pagesMetaDataTotal: any;
}

const initialState: State = {
  services: [],
  pagesMetaData: [],
  pagesMetaDataTotal: 0
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions
  //   getters: getters
};
